module.exports = __webpack_public_path__ + "components/flag/static/square/sv-79c6e39f5540693f238509bcc1561d45.svg";